import { CapacitorPluginSce, CapacitorPluginScePlugin } from 'capacitor-plugin-sce';
import { CapacitorPluginSceiOS } from "../../capacitor-plugin-sce-ios";
import { EDeviceType } from "../shared/enums/EDeviceType";


export class SceFactory {

    public static getSceInstance(deviceTypeUser : EDeviceType): CapacitorPluginScePlugin {
        return deviceTypeUser === EDeviceType.ANDROID
				? CapacitorPluginSce
				: deviceTypeUser === EDeviceType.IOS
				? CapacitorPluginSceiOS
				: null;
		}
	}